export const RegionType = Object.freeze({
	North: 'North',
	West: 'West',
	East: 'East',
	Center: 'Center',
});
